import React, { useState } from 'react';
import { Form, FormFeedback, Label } from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { Campaign } from '../../types/campaign';
import { updateOrderStatusByCampaign } from '../../api/campaignApi';
import Select, { SingleValue } from 'react-select';
import { createOption, Option } from '../../helpers/selectHelpers';
import { OrderStatus } from '../../types/order';

interface BulkActionStatusCampaignModalProps {
    campaign: Campaign;
    isOpen: boolean;
    toggle: () => void;
    onUpdateData: (newData: Campaign) => void;
}

const fromStatusOptions = [
    createOption('Rascunho', OrderStatus.DRAFT),
];

const toStatusOptions = [
    createOption('Pronto', OrderStatus.READY),
];

const BulkActionStatusCampaignModal = ({ campaign, isOpen, toggle, onUpdateData }: BulkActionStatusCampaignModalProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [selectFromStatusValue, setSelectFromStatusValue] = useState<SingleValue<Option>>();
    const [selectToStatusValue, setSelectToStatusValue] = useState<SingleValue<Option>>();

    const toggleModal = () => {
        toggle();
    };

    const selectFromStatusOnChange = (option: SingleValue<Option>) => {
        setSelectFromStatusValue(option);
        handleForm.setFieldValue('fromStatus', option ? option.value : '');
    }

    const selectToStatusOnChange = (option: SingleValue<Option>) => {
        setSelectToStatusValue(option);
        handleForm.setFieldValue('toStatus', option ? option.value : '');
    }

    const handleForm: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            fromStatus: '',
            toStatus: '',
        },
        validationSchema: Yup.object({
        }),
        onSubmit: (values: any) => {
            setLoading(true);
            updateOrderStatusByCampaign(campaign.id, values)
                .then((res: any) => {
                    toggleModal();
                    onUpdateData(res);
                    toast.success('Status dos pedidos atualizado com sucesso!');
                })
                .catch(() => {
                })
                .finally(() => {
                    setLoading(false);
                });
        },
    });

    return (
        <div className={`modal ${isOpen ? 'show' : ''}`} style={{ display: isOpen ? 'block' : 'none' }} tabIndex={-1}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <Form onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleForm.handleSubmit();
                        return false;
                    }}>
                        <div className="modal-header bg-light p-3">
                            <h5 className="modal-title">Atualização de status em massa</h5>
                            <button type="button" className="btn-close" onClick={toggleModal}></button>
                        </div>

                        <div className="modal-body">
                            <div className="mb-3">
                                <Label
                                    htmlFor="fromStatus"
                                    className="form-label"
                                >
                                    De Status
                                </Label>
                                <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isClearable={true}
                                    isSearchable={true}
                                    id="fromStatus"
                                    name="fromStatus"
                                    options={fromStatusOptions}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: !!(handleForm.touched.fromStatus && handleForm.errors.fromStatus) ? 'red' : '#ced4da',
                                        }),
                                    }}
                                    onChange={selectFromStatusOnChange}
                                    value={selectFromStatusValue}
                                />
                                {handleForm.touched.fromStatus && handleForm.errors.fromStatus ? (
                                    <FormFeedback
                                        type="invalid"
                                        style={{ display: 'block' }}>{handleForm.errors.fromStatus}</FormFeedback>
                                ) : null}
                            </div>

                            <div className="mb-3">
                                <Label
                                    htmlFor="toStatus"
                                    className="form-label"
                                >
                                    Para Status
                                </Label>
                                <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isClearable={true}
                                    isSearchable={true}
                                    id="toStatus"
                                    name="toStatus"
                                    options={toStatusOptions}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderColor: !!(handleForm.touched.toStatus && handleForm.errors.toStatus) ? 'red' : '#ced4da',
                                        }),
                                    }}
                                    onChange={selectToStatusOnChange}
                                    value={selectToStatusValue}
                                />
                                {handleForm.touched.toStatus && handleForm.errors.toStatus ? (
                                    <FormFeedback
                                        type="invalid"
                                        style={{ display: 'block' }}>{handleForm.errors.toStatus}</FormFeedback>
                                ) : null}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="submit"
                                className="btn btn-success btn-label right ms-auto nexttab nexttab"
                            >
                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                {loading && <span className="spinner-border spinner-border-sm me-2" role="status"
                                                  aria-hidden="true"></span>}
                                Atualizar
                            </button>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default BulkActionStatusCampaignModal;